// extracted by mini-css-extract-plugin
export var pillWrapper = "_mp-0";
export var showOverflow = "_mp-1";